module.exports = __webpack_public_path__ + "5fab8b9f14510b9d58383e6e602bfb2f.wav";